import { EnumBuilder } from '@mntn-dev/utility-types'
import type { z } from 'zod'
import { InvoicePaymentTerms } from './invoice-payment-terms.ts'

/**
 * InvoiceTerm
 */
export const [InvoiceTerms, InvoiceTermsSchema, InvoiceTermsMap] = EnumBuilder(
  'none',
  ...InvoicePaymentTerms
)

export type InvoiceTerms = z.infer<typeof InvoiceTermsSchema>
